import { useGetAllFieldsQuery } from '../../../store/api/customRequirements.api';
import { FC } from 'react';
import { DashboardPage } from './dashboard.page';

export const DashboardAdminLevelPage: FC = () => <DashboardPage isAdminRoute={true} />;
